export default "__VITE_ASSET__Vp5Dqx2j__"